export enum SubcontractorRequestStatus {
  Active = 'active',
  PendingCustomerReview = 'pending_customer_review',
  Rejected = 'rejected',
  Inactive = 'inactive',
}
